import React from "react";
import { Header2, SkeletonLoader } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";

export const VersionNameLoader = ({ name, className, loading }) => {
  if (loading)
    return (
      <SkeletonLoader
        as="div"
        data-testid="loader"
        className={classNames("tw-h-[25px]", className)}
      />
    );

  return (
    <Header2
      weight="bold"
      wordBreak="all"
      className={classNames("tw-mt-1 tw-align-middle tw-mb-2", className)}
      as="div"
      dangerouslySetInnerHTML={{ __html: name }}
    />
  );
};

VersionNameLoader.propTypes = {
  name: PropTypes.string,
  className: PropTypes.string,
  loading: PropTypes.bool,
};

VersionNameLoader.defaultProps = {
  loading: true,
};
